<template>
  <div class="share-modal">
    <div class="image-container">
      <img class="image" :src="userShareImageLocal">
    </div>
    <div class="buttons-container">
      <BaseButtonShareFacebook :url="$content.shareUrl" :quote="quote"/>
      <BaseButtonShareTwitter :url="$content.shareUrl" :quote="quote"/>
      <BaseButtonDownload :url="userShareImageLocal"/>
      <BaseButtonExpand state="close" @click.native="$emit('close')"/>
    </div>
  </div>
</template>

<script>
import BaseButtonExpand from '@/components/BaseButtonExpand/BaseButtonExpand'
import BaseButtonShareFacebook from '@/components/BaseButtonShareFacebook/BaseButtonShareFacebook'
import BaseButtonShareTwitter from '@/components/BaseButtonShareTwitter/BaseButtonShareTwitter'
import BaseButtonDownload from '@/components/BaseButtonDownload/BaseButtonDownload'
import { mapState, mapGetters } from 'vuex'
export default {
  components: {
    BaseButtonExpand,
    BaseButtonShareFacebook,
    BaseButtonShareTwitter,
    BaseButtonDownload
  },
  computed: {
    ...mapState('gameplay', [
      'userShareImageLocal',
      'userShareImageHosted'
    ]),
    ...mapGetters('gameplay', [
      'userWonGame',
      'opponent'
    ]),
    quote () {
      return this.opponent.id === 'KHABIB_NURMAGOMEDOV' && this.userWonGame
        ? `I brought my game face against ${this.opponent.name} in the UFC Ultimate Staredown and won! Bring on UFC 244.`
        : `I went face to face against ${this.opponent.name} in UFC Ultimate Staredown. See if you have what it takes!`
    }
  }
}
</script>

<style lang="scss" scoped>
.share-modal {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.image-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.image {
  width: 100%;
  height: auto;
  display: block;
}
.buttons-container {
  flex-shrink: 0;
  width: 100%;
  display: flex;
  justify-content: space-around;
}
</style>
